import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import EntityTableRow, { EntityTableRowProps } from 'components/EntityTableRow';
import TableCell from 'components/TableCell';

import { TermsListRow_term$key } from '__generated__/TermsListRow_term.graphql';
import Icon from 'components/Icon';
import Link from '@mui/material/Link';

type Props = EntityTableRowProps & {
  term: TermsListRow_term$key;
};

const agreementBlocks = {
  BAGGAGE: 'Bagažas',
  TRANSFER: 'Pervežimas',
};

const TermsListRow: FC<Props> = ({ term, ...props }) => {
  const termData = useFragment(
    graphql`
      fragment TermsListRow_term on Term {
        id
        icon
        name
        agreementBlock

        ...EntityTableRow_entity
      }
    `,
    term
  );

  const { id, icon, name, agreementBlock } = termData;

  return (
    <EntityTableRow entity={termData} {...props}>
      <TableCell>{icon && <Icon icon={icon} />}</TableCell>

      <TableCell>
        <Link href={id}>{name}</Link>
      </TableCell>

      <TableCell center>
        {agreementBlock && agreementBlocks[agreementBlock]}
      </TableCell>
    </EntityTableRow>
  );
};

export default TermsListRow;
